import React from "react";
import Form from "react-bootstrap/Form";

const FaxDispositionNotes = ({
  notesConfig,
  value,
  onChange,
  disabled = false,
}) => (
  <Form.Group className="small-top-spacer small-bottom-spacer">
    <Form.Label>{notesConfig.label}</Form.Label>
    <Form.Control
      id={notesConfig.controlId || "faxdisposition-form-notes"}
      as="textarea"
      rows={3}
      placeholder={notesConfig.placeholder}
      onChange={onChange}
      value={value}
      name="notes"
      disabled={disabled}
    />
    <Form.Text className="text-muted">{notesConfig.helpText}</Form.Text>
  </Form.Group>
);

export default FaxDispositionNotes;
